import chatsSchema from './chatsSchema'

const chatFormSchema = (t) => chatsSchema(t)

export default chatFormSchema
